import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import changeCards, { changeQuantity } from "../../store/action";
import { changeCounter } from "../../store/action";
import "./cards.css";
import { useAuth } from "../../context/GlobalProvider";

import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import i18next from "i18next";
import cookies from "js-cookie";

const Cards = () => {
  //language
  // const [inputText, setInputText] = useState(1);
  const currentLanguageCode = cookies.get("i18next") || "en";
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { user } = useAuth();
  const getBasketTotal = (cards) =>
    cards.reduce((amount, item) => {
      return amount + item.price * quant;
    }, 0);
  const dispatch = useDispatch();
  const cards = useSelector((state) => state.card);
  // const [quantity, setQuantity] = useState(1);
  const counter = useSelector((state) => state.count);
  const quant = useSelector((state) => state.quantity);
  // const handleChange = (e) => {
  //   // 👇 Store the input value to local state
  //   setInputText(e.target.value);
  // };
  // const handleDecremet = () => {
  //   if (quantity > 1) {
  //     setQuantity((prevCount) => prevCount - 1);
  //   }
  // };

  // const handleIncrement = () => {
  //   if (quantity < 10) {
  //     setQuantity((prevCount) => prevCount + 1);
  //   }
  // };
  return (
    <>
      <div className="container-fluid ">
        <h3>
          {t("welcome_message")} {user ? `${user.email}` : "Guest"}
        </h3>

        {/* <h3 className="hello">Hello ahmed</h3> */}
        <h2 className="checkout-title">{t("basket")}</h2>
        <hr />
        <div className="row ">
          <div className="col-lg-8 col-md-6">
            {cards.map((prd, index) => {
              return (
                <div className="checkoutProduct">
                  <img className="checkoutProduct-image" src={prd.image} />
                  <div className="checkoutProduct-info">
                    <p className="checkoutProduct-title">
                      {currentLanguageCode === "en"
                        ? `${prd.description}`
                        : `${prd.descriptionar}`}
                    </p>
                    <p className="checkoutProduct-price">
                      <strong>$</strong>
                      <strong>{prd.price}</strong>

                      <div className="input-group">
                        <button
                          type="button"
                          // onClick={() => {
                          //   handleDecremet();
                          // }}
                          onClick={() => {
                            const item = cards.findIndex(
                              (product) => product.name === prd.name
                            );

                            dispatch(changeQuantity(quant - 1));
                          }}
                          className="input-group-text"
                        >
                          -
                        </button>

                        <div className="form-control text-center">{quant}</div>
                        <button
                          type="button"
                          // onClick={handleIncrement}
                          onClick={() => {
                            const item = cards.findIndex(
                              (product) => product.name === prd.name
                            );

                            dispatch(changeQuantity(quant + 1));
                          }}
                          className="input-group-text"
                        >
                          +
                        </button>
                      </div>
                      {/* <p>
                        <strong>Qty</strong> :{" "}
                        <input
                          type="number"
                          onChange={handleChange}
                          value={inputText}
                        ></input>
                      </p> */}
                    </p>

                    <button
                      style={{
                        fontSize: "13px",
                        borderWidth: "1px",
                        borderRadius: "8px",
                        borderStyle: "solid",
                        padding: "0 10px 0 11px",
                      }}
                      onClick={() => {
                        let index = cards.findIndex(
                          (ele) => ele.name === prd.name
                        );
                        cards.splice(index, 1);
                        dispatch(changeCards([...cards]));
                        dispatch(changeCounter(counter - 1));
                      }}
                    >
                      {t("remove")}
                    </button>
                    <hr></hr>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="subtotal">
              <p>
                {" "}
                {t("subtotal")} <strong>${getBasketTotal(cards)}</strong>
              </p>
              <small className="subtotal__gift">
                <input type="checkbox" /> {t("gift")}
              </small>
              <button
                onClick={() =>
                  user ? navigate("/checkout") : navigate("/login")
                }
              >
                {" "}
                {t("proceed")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cards;
